import { useState } from 'react'
import { axiosInstance } from '../helpers'
import {
    PricingContracts,
    ServiceContractGroup,
} from '../models/ServiceContract/types'
import { toast } from 'react-toastify'

export const usePricing = () => {
    const [pricingContracts, setPricingContracts] = useState<
        PricingContracts[]
    >([])

    const [
        pendingServiceContractGroups,
        setPendingServiceContractGroups,
    ] = useState<ServiceContractGroup[]>([])

    const fetchPricingContracts = async (vendorId: number) => {
        const response = await axiosInstance.get(
            `service-contract/group/grouped/`,
            {
                params: {
                    vendor_id: vendorId,
                },
            },
        )
        console.log('fetchPricingContracts', response.data)
        setPricingContracts(response.data)
        return response.data
    }

    const generatePricingContractPDF = async (vendorId: number) => {
        console.log('generatePricingContractPDF', vendorId)
        const response = await axiosInstance.post(
            `service-contract/group/generate-pdf/`,
            {
                vendor_id: vendorId,
            },
        )
        return response.data
    }

    const fetchPendingPricingRequests = async () => {
        try {
            const response = await axiosInstance.get(
                `company/apartment/get_pending_pricing_requests/`,
            )

            const serviceContractGroups: ServiceContractGroup[] = response.data
            setPendingServiceContractGroups(serviceContractGroups)
            return serviceContractGroups
        } catch (error) {
            toast.error('Error fetching pending pricing requests')
            return Promise.reject(error)
        }
    }

    return {
        pricingContracts,
        pendingServiceContractGroups,
        setPendingServiceContractGroups,
        fetchPricingContracts,
        generatePricingContractPDF,
        fetchPendingPricingRequests,
    }
}
